import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-py-xs" }
const _hoisted_2 = { class: "fs-13px text-cool-gray-80" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = {
  key: 0,
  class: "row gap-sm items-center"
}
const _hoisted_5 = { class: "fs-13px fw-500 text-cool-gray-70" }
const _hoisted_6 = { class: "AvailabilityDialog__time fs-15px text-cool-gray-100 text-right" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = {
  key: 0,
  class: "row gap-sm items-center justify-end"
}
const _hoisted_9 = { class: "fs-13px fw-500 text-cool-gray-70" }
const _hoisted_10 = { class: "AvailabilityDialog__time fs-15px text-cool-gray-100 text-right" }
const _hoisted_11 = {
  key: 1,
  class: "fs-13px text-cool-gray-80 block text-right"
}

import { IAvailability } from 'src/common/interfaces'
import { IAvailabilityDayMapping } from './interfaces/availabilityDialog.interface'
import translationObject from './translate/availabilityDialog.translate'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  data: IAvailability | null
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'AvailabilityDialog' },
  __name: 'AvailabilityDialog',
  props: /*@__PURE__*/_mergeModels({
    data: {}
  }, {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel<boolean>(__props, "modelValue")


const { t } = translate(translationObject)
const { t: globalT } = translate(globalTranslateObject)

const dayMapping: IAvailabilityDayMapping = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
}

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createBlock(_component_k_dialog, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    title: __props.data?.name,
    "container-class": "AvailabilityDialog"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.availability, (value, key, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "column no-wrap"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value?.length ? value : [null], (slot, slotIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: slotIndex,
                class: "row flex-1 q-py-xs q-px-sm"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-6", { invisible: slotIndex > 0 }])
                }, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(dayMapping[key]), 1 /* TEXT */)
                ], 2 /* CLASS */),
                _createElementVNode("div", _hoisted_3, [
                  slot
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('from')) + ": ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(slot?.start), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  slot
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('to')) + ": ", 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(slot?.end), 1 /* TEXT */)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(globalT)('closed')), 1 /* TEXT */))
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (__props.data && index < Object.keys(__props.data.availability).length - 1)
              ? (_openBlock(), _createBlock(_component_k_divider, {
                  key: 0,
                  dotted: true,
                  color: "cool-gray-50",
                  class: "q-my-12"
                }))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title"]))
}
}

})